<template>
    <dx-grid
        url="accounts"
        :columns="columns"
        :title="title"
        navigationPath="Account View"
        navigationField="accountID"
    ></dx-grid>
</template>

<script>
import { formatCurrency } from "../utils/helpers.js";
export default {
    data: () => ({
        title: "Accounts",
        columns: [
            {
                field: "name",
                label: "Name",
                format: "",
                visible: true,
                filterType: "",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                field: "accountID",
                label: "Account ID",
                link: "Account View",
                format: "",
                template: "link-cell-template",
                visible: true,
                filterType: "",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                field: "hname",
                label: "Hebrew Name",
                format: "",
                visible: true,
                filterType: "",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                field: "homePhone",
                label: "Home Phone",
                format: "",
                visible: true,
                filterType: "",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                field: "cellPhone",
                label: "Cellphone",
                format: "",
                visible: true,
                filterType: "",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                field: "address1",
                label: "Address",
                format: "",
                visible: true,
                filterType: "",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                field: "emailAddress",
                label: "Email",
                format: "",
                visible: true,
                filterType: "",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                field: "activeSchedules",
                label: "Active Schedules",
                type: "number",
                format: "",
                visible: true,
                filterType: "",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                field: "totalScheduledAmount",
                label: "Total Scheduled Amount",
                type: "number",
                format: "currency",
                visible: true,
                filterType: "",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                field: "tuitionBalance",
                label: "Tuition Balance",
                type: "number",
                format: "currency",
                visible: true,
                filterType: "",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                field: "transportationBalance",
                label: "Transportation Balance",
                type: "number",
                format: "currency",
                visible: true,
                filterType: "",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                field: "accountLinkID",
                label: "Account Link ID",
                format: "",
                visible: true,
                filterType: "",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                field: "father",
                label: "Father",
                format: "",
                visible: true,
                filterType: "",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                field: "shver",
                label: "Shver",
                format: "",
                visible: true,
                filterType: "",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                field: "pinNum",
                label: "Pin Number",
                format: "",
                visible: true,
                filterType: "",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                field: "busAddress1",
                label: "Bus Address 1",
                format: "",
                visible: false,
                filterType: "",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                field: "busAddress2",
                label: "Bus Address 2",
                format: "",
                visible: false,
                filterType: "",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                field: "lastSuccessfulSchedule",
                label: "Last Successful Schedule",
                type: "date",
                format: "",
                visible: true,
                filterType: "",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                field: "nextScheduleDate",
                label: "Next Schedule Date",
                type: "date",
                format: "",
                visible: true,
                filterType: "",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                field: "lastUpdated",
                label: "Last Updated",
                type: "date",
                format: "",
                visible: true,
                filterType: "",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                field: "lastLoggedIn",
                label: "Last Logged In",
                type: "date",
                format: "",
                visible: true,
                filterType: "",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                field: "registrationStatus",
                label: "Registration Status",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                field: "studentClasses",
                label: "Student Classes",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                field: "missingRequirements",
                label: "Missing Requirements",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                field: "students",
                label: "Students",
                visible: true,
                type: "number",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
        ],
    }),
    methods: {},
};
</script>
<style></style>
